/* Components */
import App from './App.svelte';

/* Tailwind */
import '../dist/styles.min.css';

const app = new App({
  target: document.querySelector('#app'),
  props: {}
});

export default app;
